import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7333c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"196px"} }
const _hoisted_2 = { class: "font-bold text-sm mb-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-25 bg-gray-100 animate-pulse" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-2 rounded w-100 bg-gray-100 my-1 animate-pulse" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "text-left"
}
const _hoisted_9 = { class: "mb-1 text-sm font-medium flex justify-between" }
const _hoisted_10 = { class: "mt-3 text-left" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-2 rounded w-40 bg-gray-100 animate-pulse mt-2 mb-3" }, null, -1))
const _hoisted_13 = { class: "flex gap-3" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "font-medium text-sm" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = {
  key: 1,
  class: "flex mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DarkstoreInfoWindowOrderInfoBar = _resolveComponent("DarkstoreInfoWindowOrderInfoBar")!
  const _component_DarkstoreInfoWindowDriver = _resolveComponent("DarkstoreInfoWindowDriver")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.darkstore.name), 1),
    (_ctx.orderLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
            return _createElementVNode("div", { key: i }, _hoisted_6)
          }), 64))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.showAllDrivers)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                role: "button",
                class: "text-sm font-bold",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAllDrivers = false))
              }, _toDisplayString(_ctx.vm.$t('Show orders info')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.vm.$t('orders.last24hoursTotal')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo.total), 1)
                ]),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderStatuses, (s) => {
                    return (_openBlock(), _createBlock(_component_DarkstoreInfoWindowOrderInfoBar, {
                      key: s,
                      title: _ctx.vm.$t(`orders.statuses.${s}`),
                      totalOrderCount: _ctx.orderInfo.total,
                      orderCount: _ctx.orderInfo[s],
                      color: _ctx.colors[s]
                    }, null, 8, ["title", "totalOrderCount", "orderCount", "color"]))
                  }), 128))
                ])
              ]))
        ])),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.driverLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "rounded-full w-8 h-8 bg-gray-100 animate-pulse"
                })
              }), 64))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.vm.$t('Drivers clocked in')) + " " + _toDisplayString(_ctx.drivers.length), 1),
            (_ctx.showAllDrivers)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drivers, (driver, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex items-center my-1"
                    }, [
                      _createVNode(_component_DarkstoreInfoWindowDriver, {
                        name: driver.first_name,
                        surname: driver.last_name
                      }, null, 8, ["name", "surname"]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(driver.first_name) + " " + _toDisplayString(driver.last_name), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driverAvatars, (driver, index) => {
                    return (_openBlock(), _createBlock(_component_DarkstoreInfoWindowDriver, {
                      key: index,
                      name: driver.first_name,
                      surname: driver.last_name,
                      class: _normalizeClass([{'driver-next-item' : index}])
                    }, null, 8, ["name", "surname", "class"]))
                  }), 128)),
                  (_ctx.drivers.length - _ctx.driverAvatars.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        role: "button",
                        class: "rounded-full w-8 h-8 bg-gray-100 text-sm flex items-center justify-center font-medium border ml-1",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAllDrivers = true))
                      }, " +" + _toDisplayString(_ctx.drivers.length - _ctx.driverAvatars.length), 1))
                    : _createCommentVNode("", true)
                ]))
          ]))
    ])
  ]))
}